import { axios } from "helper/axios";
import { sentimentTrackerOnboardingConstants } from "./sentimentTrackerOnboardingConstants";

const sentimentTrackerOnboardingApis = {};

sentimentTrackerOnboardingApis.getOnboardingData = () => {
    return axios.get(sentimentTrackerOnboardingConstants.SENTIMENT_ONBOARDING_DATA_API);
};

sentimentTrackerOnboardingApis.initiateDocumentSigning = () => {
    return axios.post(
        sentimentTrackerOnboardingConstants.SENTIMENT_INITIATE_DOCUMENT_SIGNING_API
    );
};

sentimentTrackerOnboardingApis.redirectOnboarding = () => {
    return axios.post(
        sentimentTrackerOnboardingConstants.SENTIMENT_DASHBOARD_REDIRECT_API
    )
};

export { sentimentTrackerOnboardingApis };
